// extracted by mini-css-extract-plugin
export default {"container":"cookieBannerOpener_container","link":"cookieBannerOpener_link"};